<template lang="html">
  <Row style="padding: 3vw 2vw 6vw 2vw; background: #fcfcfc">
    <h2 style="font-size: 28px; text-align: center; padding: 2vw 10vw 10vw;">{{ title }}</h2>
    <Row v-for="(section, $index) in sections" :key="$index">
      <ContentImageSection
        :windowWidth="windowWidth"
        :isMobile="isMobile"
        :title="section.title"
        :descriptions="section.descriptions"
        :image="section.image"
        :component="section.component"
        :type="!isMobile? isEven($index) ? 'img-right' : 'img-left' : 'img-right'"
        :cta="true">
      </ContentImageSection>
    </Row>
  </Row>
</template>
<script>
import ContentImageSection from './ContentImageSection';

export default {
  components: { ContentImageSection },
  props: {
    windowWidth: Number,
    isMobile: Boolean,
    title: String,
    sections: Array,
  },
  methods: {
    isEven: n => (n === 0 || !!(n && !(n % 2))),
  },
};
</script>
<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/DemonstrationSection.vue